import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

import { Select2Data } from "../../../utils/common";

export const AllPermmission = createAsyncThunk(
  "common/masters/all-permission",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllPermmission);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Country - Get All
export const AllCountry = createAsyncThunk(
  "common/masters/all-country",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllCountry);

      return await Select2Data(res?.data?.data, "country_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// State - Get All (for a specific country)
export const AllState = createAsyncThunk(
  "common/masters/all-state/:id",
  async ({ countryId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllState}/${countryId}`);

      return await Select2Data(res?.data?.data, "state_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allStates = createAsyncThunk(
  "/common/masters/all-states",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.allStates}?name=${filter}`);
      return await Select2Data(res.data.data, "state_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllDistrict = createAsyncThunk(
  "common/masters/all-district/:id",
  async ({ stateId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllDistrict}/${stateId}`);

      return await Select2Data(res?.data?.data, "district_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllTaluka = createAsyncThunk(
  "common/masters/all-taluka/:id",
  async ({ districtId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllTaluka}/${districtId}`);

      return await Select2Data(res?.data?.data, "taluka_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// export const AllArea = createAsyncThunk(
//   "common/masters/all-area/:id",
//   async ({ stateId, name = "" }, { rejectWithValue }) => {
//     try {
//       const res = await GET(`${APIS.Commons.AllArea}/${stateId}`);

//       return await Select2Data(res?.data?.data, "area_id");
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   },
// );

export const AllArea = createAsyncThunk(
  "common/masters/all-area/:id",
  async ({ talukaId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllArea}/${talukaId}`);

      return await Select2Data(res?.data?.data, "area_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllPurposeRoles = createAsyncThunk(
  "common/masters/all-purpose-roles/:id",
  async ({ stateId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllPurposeRoles}`);

      return await Select2Data(res?.data?.data, "role_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllExpertPurpose = createAsyncThunk(
  "common/masters/all-expert-purpose/:id",
  async ({ stateId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllExpertPurpose}`);

      return await Select2Data(res?.data?.data, "role_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllSubscriptionFeatures = createAsyncThunk(
  "common/masters/all-subscription-features/:id",
  async ({ stateId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllSubscriptionFeatures}`);

      return await Select2Data(res?.data?.data, "role_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllSubscriptionValidity = createAsyncThunk(
  "common/masters/all-subscription-validity/:id",
  async ({ stateId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllSubscriptionValidity}`);

      return await Select2Data(res?.data?.data, "role_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllLoginRoles = createAsyncThunk(
  "common/masters/all-login-roles/:id",
  async ({ stateId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllLoginRoles}`);

      return await Select2Data(res?.data?.data, "role_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllUserStatus = createAsyncThunk(
  "common/masters/all-user-status",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllUserStatus);

      return await Select2Data(res?.data?.data, "user_status_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllPropertyStatus = createAsyncThunk(
  "common/masters/all-property-status",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllPropertyStatus);

      return await Select2Data(res?.data?.data, "user_status_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllPropertyType = createAsyncThunk(
  "common/masters/all-property-type",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllPropertyType);

      return await Select2Data(res?.data?.data, "property_type_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllPostedBy = createAsyncThunk(
  "common/masters/all-posted-by",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllPostedBy);

      return await Select2Data(res?.data?.data, "posted_by_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllBrokerPurpose = createAsyncThunk(
  "common/masters/all-broker-purpose",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllBuilderPurpose);

      return await Select2Data(res?.data?.data, "broker_purpose_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allPostedBy = createAsyncThunk(
  "/common/masters/all-posted-by",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllPostedBy}?name=${filter}`);
      return await Select2Data(res.data.data, "posted_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allBHK = createAsyncThunk(
  "/common/masters/all-BHK",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllBHK}?name=${filter}`);
      return await Select2Data(res.data.data, "bhk_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allFurnishType = createAsyncThunk(
  "/common/masters/all-FurnishType",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllFurnishType}?name=${filter}`);
      return await Select2Data(res.data.data, "furnish_type_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allFacing = createAsyncThunk(
  "/common/masters/all-Facing",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllFacing}?name=${filter}`);
      return await Select2Data(res.data.data, "facing_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allAvailability = createAsyncThunk(
  "/common/masters/all-Availability",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllAvailability}?name=${filter}`);
      return await Select2Data(res.data.data, "availability_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allAminities = createAsyncThunk(
  "/common/masters/all-Aminities",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllAminities}?name=${filter}`);
      return await Select2Data(res.data.data, "aminities_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allKeyHighlight = createAsyncThunk(
  "/common/masters/all-key-highlight",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllKeyHighlight}?name=${filter}`);
      return await Select2Data(res.data.data, "key_highlight_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allWorkStart = createAsyncThunk(
  "/common/masters/all-work-start",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.allWorkStart}?name=${filter}`);
      return await Select2Data(res.data.data, "work_start_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// City - Get All (for a specific state)
export const AllCity = createAsyncThunk(
  "common/masters/all-city/:id",
  async ({ stateId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllCity}/${stateId}?name=${name}`);
      return await Select2Data(res.data.data, "city_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Pincode - Get All (for a specific city)
export const AllPincode = createAsyncThunk(
  "common/masters/all-pincode/:id",
  async ({ cityId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllPincode}/${cityId}?name=${name}`,
      );
      return await Select2Data(res.data.data, "pincode_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "common",
  initialState: {
    all_country: [],
    all_state: [],
    all_district: [],
    all_taluka: [],
    all_area: [],
    all_purpose_role: [],
    all_expert_purpose: [],
    all_user_status: [],
    all_subscription_features: [],
    all_subscription_validity: [],
    all_login_roles: [],
    all_property_status: [],
    all_property_type: [],
    all_posted_by: [],
    all_broker_purpose: [],
    all_permission: [],
    all_posted_by: [],
    all_bhk: [],
    all_furnish_type: [],
    all_facing: [],
    all_availability: [],
    all_aminities: [],
    all_key_highlight: [],
    all_work_start: [],
    all_states: [],
    all_city: [],
    all_pincode: [],
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(AllCountry.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCountry.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_country = action.payload || [];
      })
      .addCase(AllCountry.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllState actions
      .addCase(AllState.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllState.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_state = action.payload || [];
      })
      .addCase(AllState.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllCity actions
      .addCase(AllDistrict.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllDistrict.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_district = action.payload || [];
      })
      .addCase(AllDistrict.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllPincode actions
      .addCase(AllTaluka.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllTaluka.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_taluka = action.payload || [];
      })
      .addCase(AllTaluka.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllArea.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllArea.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_area = action.payload || [];
      })
      .addCase(AllArea.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllPurposeRoles.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPurposeRoles.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_purpose_role = action.payload || [];
      })
      .addCase(AllPurposeRoles.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllExpertPurpose.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllExpertPurpose.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_expert_purpose = action.payload || [];
      })
      .addCase(AllExpertPurpose.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllSubscriptionFeatures.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllSubscriptionFeatures.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_subscription_features = action.payload || [];
      })
      .addCase(AllSubscriptionFeatures.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllSubscriptionValidity.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllSubscriptionValidity.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_subscription_validity = action.payload || [];
      })
      .addCase(AllSubscriptionValidity.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllLoginRoles.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllLoginRoles.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_login_roles = action.payload || [];
      })
      .addCase(AllLoginRoles.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllUserStatus.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllUserStatus.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_user_status = action.payload || [];
      })
      .addCase(AllUserStatus.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllPropertyStatus.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPropertyStatus.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_property_status = action.payload || [];
      })
      .addCase(AllPropertyStatus.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllPropertyType.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPropertyType.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_property_type = action.payload || [];
      })
      .addCase(AllPropertyType.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllPostedBy.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPostedBy.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_posted_by = action.payload || [];
      })
      .addCase(AllPostedBy.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllBrokerPurpose.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllBrokerPurpose.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_broker_purpose = action.payload || [];
      })
      .addCase(AllBrokerPurpose.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllPermmission.pending, (state) => {
        console.log("action.payload pending");
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPermmission.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;

        state.all_permission = action.payload || {};
      })
      .addCase(AllPermmission.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;

        state.error = action.payload;
      })

      .addCase(allPostedBy.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allPostedBy.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_posted_by = action.payload || [];
      })
      .addCase(allPostedBy.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(allBHK.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allBHK.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_bhk = action.payload || [];
      })
      .addCase(allBHK.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(allFurnishType.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allFurnishType.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_furnish_type = action.payload || [];
      })
      .addCase(allFurnishType.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(allFacing.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allFacing.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_facing = action.payload || [];
      })
      .addCase(allFacing.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(allAvailability.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allAvailability.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_availability = action.payload || [];
      })
      .addCase(allAvailability.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(allAminities.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allAminities.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_aminities = action.payload || [];
      })
      .addCase(allAminities.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(allKeyHighlight.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allKeyHighlight.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_key_highlight = action.payload || [];
      })
      .addCase(allKeyHighlight.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(allWorkStart.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allWorkStart.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_work_start = action.payload || [];
      })
      .addCase(allWorkStart.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(allStates.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allStates.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_states = action.payload || [];
      })
      .addCase(allStates.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllCity.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCity.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_city = action.payload || [];
      })
      .addCase(AllCity.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllPincode actions
      .addCase(AllPincode.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPincode.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_pincode = action.payload || [];
      })
      .addCase(AllPincode.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
